var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRequestAccepted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 12.6667L13.8 14.2222L17 11.1111M9 10.3333H5.8C4.30899 10.3333 3.56348 10.3333 2.97541 10.5702C2.19132 10.8859 1.56837 11.4916 1.24359 12.2539C1 12.8256 1 13.5504 1 15M11.8 1.22615C12.9727 1.68767 13.8 2.80546 13.8 4.11111C13.8 5.41676 12.9727 6.53455 11.8 6.99608M10.2 4.11111C10.2 5.82933 8.76731 7.22222 7 7.22222C5.23269 7.22222 3.8 5.82933 3.8 4.11111C3.8 2.39289 5.23269 1 7 1C8.76731 1 10.2 2.39289 10.2 4.11111Z",
    stroke: "#535353",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRequestAccepted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/requestAccepted.154edc27.svg";
export { ForwardRef as ReactComponent };